import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8c4c9332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "captcha-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content-footer" }
const _hoisted_4 = { class: "operate-icon" }
const _hoisted_5 = { class: "operate-button" }

import { computed, nextTick, ref, watch } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { captchaCheckService } from '@/common/basis/root-injector'
import {
  CaptchaDataRes,
  CaptchaService,
} from '@/views/_components/captcha-dialog/captcha.service'
import { ElMessage } from 'element-plus'
import { throttle } from '@/utils/throttle'


export default /*#__PURE__*/_defineComponent({
  __name: 'captcha',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: '350px',
  },
  height: {
    type: String,
    default: '117px',
  },
},
  emits: ['confirm'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const injector = useReflectiveInjector([CaptchaService])
const captchaService = injector.get(CaptchaService)

const captchaData = ref({} as CaptchaDataRes)
const captchaCode = ref('')
const captchaInput = ref()

const style = computed(() => `width:${props.width}; height:${props.height};`)

function handleRefresh() {
  captchaData.value = {} as CaptchaDataRes
  captchaService.getCaptchaData().then((response) => {
    captchaCheckService.setCaptchaId(response.captcha_id)
    captchaData.value = response
  })
}

function doConfirm () {
  if (!captchaCode.value) {
    ElMessage.error('请先输入验证码')
    return
  }
  emits('confirm', captchaCode.value)
}

const throttledDoConfirm = throttle(doConfirm, 500)

function handleConfirm (event) {
  // 强制阻止事件冒泡
  if (event) {
    event.stopPropagation()
    event.preventDefault()
  }
  throttledDoConfirm()
}

watch(() => props.visible, (visible) => {
  if (visible) {
    handleRefresh()
    nextTick(() => captchaInput.value?.$el?.querySelector?.('input')?.focus?.())
  } else {
    captchaCode.value = ''
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "content-body",
      style: _normalizeStyle(style.value)
    }, [
      _withDirectives(_createElementVNode("img", {
        class: "picture",
        src: captchaData.value.captcha_image,
        alt: "",
        onClick: handleRefresh
      }, null, 8, _hoisted_2), [
        [_vShow, captchaData.value.captcha_image]
      ]),
      _createVNode(_component_CmSvgIcon, {
        name: "views/_components/captcha-dialog/_images/loading-icon",
        class: "loading",
        monochrome: "",
        "aria-hidden": false,
        "aria-label": "正在加载中..."
      })
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CmSvgIcon, {
          name: "views/_components/captcha-dialog/_images/refresh-icon",
          monochrome: "",
          "aria-hidden": false,
          "aria-label": "刷新"
        })
      ]),
      _createVNode(_component_el_input, {
        ref_key: "captchaInput",
        ref: captchaInput,
        class: "cm-ui-mr10",
        size: "small",
        placeholder: "请输入图形验证码",
        style: {"max-width":"140px"},
        modelValue: captchaCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((captchaCode).value = $event)),
        onKeydown: _withKeys(_withModifiers(handleConfirm, ["stop"]), ["enter"])
      }, null, 8, ["modelValue", "onKeydown"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _withModifiers(handleConfirm, ["stop"]),
          style: {"width":"80px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确认 ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})